import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import Loading from "./Loading";

const AuthRoute = ({ isAuth }) => {
  const auth = useSelector((state) => state.auth);
  if (auth.loading) {
    return <Loading />;
  }

  if (isAuth) {
    if (!auth.token) {
      return <Navigate to="/login" replace />;
    }
  } else {
    if (auth.token) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <Outlet />;
};

export default AuthRoute;
